import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { SgoModulo } from '../../models/sgo-modulo.model';
import { SgoModuloService } from '../../services/sgo-modulo.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-sgo-modulo-edit',
  templateUrl: './sgo-modulo-edit.component.html',
  styleUrls: ['./sgo-modulo-edit.component.scss']
})
export class SgoModuloEditComponent extends BaseFormComponent<SgoModulo> implements OnInit {

  actionLabel: string = 'Novo';

  constructor(
    private myService: SgoModuloService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back(['projetos/admin-spgg/sgo-modulos']);
  }

  getDataCreate(): SgoModulo {
    let data: SgoModulo;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: SgoModulo) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.loaded();
              this.msgError();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: SgoModulo) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/admin-spgg/sgo-modulos/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.loaded();
              this.msgError();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
}
